/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;max-width:600px}.title-container[_ngcontent-%COMP%]{margin:-24px -24px 24px;background-color:#377dff;display:flex;align-items:center;justify-content:space-between;padding:8px}.title[_ngcontent-%COMP%]{text-align:center;color:#fff;margin:0;font-weight:700}.close-icon[_ngcontent-%COMP%]{color:#fff}.close-btn[_ngcontent-%COMP%]{margin:-8px}"];
export { styles as styles };
